module.exports = __webpack_public_path__ + "img/rain.07dff5df.svg";